export default ({ $wire }) => ({
    isOpen: false,
    exitIntentFired: false,

    init() {
        // Check if user has interacted with the page
        const events = ['mousedown', 'keydown', 'touchstart'];
        const handleUserInteraction = () => {
            this.bindExitEventListener();
            events.forEach(event => document.removeEventListener(event, handleUserInteraction));
        };
        events.forEach(event => document.addEventListener(event, handleUserInteraction, { once: true }));

        Livewire.on('open-similar-listings-modal', () => {
            this.open();
        });
    },

    open() {
        this.isOpen = true;
        document.body.style.overflow = 'hidden';
        document.body.setAttribute('data-modal-shown', 'true');
    },

    close() {
        this.isOpen = false;
        document.body.style.overflow = 'auto';
        document.body.setAttribute('data-modal-shown', 'false');
    },

    bindExitEventListener() {
        const onMouseLeave = () => {
            setTimeout(() => {
                if (this.exitIntentFired) return;
                this.exitIntentFired = true;

                if (
                    document.body.getAttribute('data-modal-shown') === 'true' ||
                    document.body.getAttribute('data-modal-contact-shown') === 'true'
                ) {
                    return;
                }
                Livewire.dispatch('detailPageExitIntent');
                document.removeEventListener('mouseleave', onMouseLeave);
            }, 400);
        };

        document.addEventListener('mouseleave', onMouseLeave);

        const onUnfocus = () => {
            if (this.exitIntentFired) return;
            this.exitIntentFired = true;

            setTimeout(() => {
                const modalShown = document.body.getAttribute('data-modal-shown') === 'true';
                const contactModalShown = document.body.getAttribute('data-modal-contact-shown') === 'true';

                if (modalShown || contactModalShown) {
                    return;
                }

                Livewire.dispatch('detailPageExitIntent');

                // Clean up listeners after firing
                document.removeEventListener('visibilitychange', handleVisibilityChange);
                document.removeEventListener('popstate', onUnfocus);
            }, 400);
        };

        const handleVisibilityChange = () => {
            if (document.hidden) {
                onUnfocus();
            }
        };

        // Setup listeners
        document.addEventListener('visibilitychange', handleVisibilityChange);
        document.addEventListener('popstate', onUnfocus);

        // Push state to capture back button
        window.history.pushState({ page: 1 }, '', '');
    },
});
